import React from 'react';
import MobileAdV3HeroSection from '../components/MobileAdV3HeroSection';

const MobileAdV3Page = () => {
  return (
    <div className="min-h-screen bg-[#0A0A12]">
      <MobileAdV3HeroSection />
    </div>
  );
};

export default MobileAdV3Page;
